import app from "@/assets/app-mockup.jpg";
import { Apple, Smartphone } from "lucide-react";

export function AppPromo() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:py-16">
      <div className="grid items-center gap-8 overflow-hidden rounded-3xl border border-border bg-[image:var(--gradient-primary)] p-8 md:grid-cols-2 md:p-12">
        <div className="text-primary-foreground">
          <h2 className="font-heading text-3xl font-bold md:text-4xl">Try the MemAds app</h2>
          <p className="mt-3 max-w-md text-white/85">
            Instant notifications on new ads, faster chat with sellers, and post in under a minute — right from your phone.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href="#" className="inline-flex items-center gap-2 rounded-xl bg-foreground px-4 py-3 text-sm font-semibold text-background shadow transition hover:brightness-110">
              <Smartphone className="h-5 w-5" />
              <span className="text-left leading-tight">
                <span className="block text-[10px] font-normal text-background/70">Get it on</span>
                Google Play
              </span>
            </a>
            <a href="#" className="inline-flex items-center gap-2 rounded-xl bg-white px-4 py-3 text-sm font-semibold text-foreground shadow transition hover:brightness-95">
              <Apple className="h-5 w-5" />
              <span className="text-left leading-tight">
                <span className="block text-[10px] font-normal text-muted-foreground">Download on the</span>
                App Store
              </span>
            </a>
          </div>
        </div>
        <div className="flex justify-center">
          <img src={app} alt="MemAds mobile app" width={1024} height={1024} loading="lazy" className="w-64 rounded-3xl shadow-2xl md:w-80" />
        </div>
      </div>
    </section>
  );
}